<template>
  <div>
    <template v-if="editMode">
      <div v-for="(dictionary, idx) in valueConvert" :key="idx">
        <dictionary-entry-selector
          :value="dictionary.entry"
          @input="dictionatyEntrySelect(dictionary.name, $event)"
          :dictionary-name="dictionary.name"
          :rules="rules"
          :excludeEntries="excludeEntries"
          :disabled="disabled"
          :editMode="editMode"
        />
      </div>
    </template>
    <template v-else>
      <div v-for="(dictionary, idx) in valueConvert" :key="idx">
        <dictionary-entry-selector
          :value="dictionary.entry"
          @input="dictionatyEntrySelect(dictionary.name, $event)"
          :dictionary-name="dictionary.name"
          :rules="rules"
          :disabled="disabled"
          :editMode="editMode"
        />
        <!-- <span v-if="idx + 1 != valueConvert.length">,&nbsp;</span> -->
      </div>
    </template>
  </div>
</template>

<script>
import DictionaryEntrySelector from "@/components/DictionaryEntrySelector";

export default {
  name: "DictionaryEntrySelectorMultLevel",
  components: { DictionaryEntrySelector },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    excludeEntries: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    valueConvert() {
      if (this.value && this.value.length > 0) {
        if (typeof this.value[0] == "string")
          return this.value.map((v) => {
            let index = v.indexOf("-");
            let name = v.substring(0, index);
            let entry = v;
            return { name, entry };
          });
        return this.value;
      }
      return this.value;
    },
  },
  methods: {
    dictionatyEntrySelect(name, entry) {
      let dictionaryEntrySelectedCopy = [...this.value];
      let indexOf = dictionaryEntrySelectedCopy.findIndex(
        (dict) => dict.name === name
      );
      dictionaryEntrySelectedCopy[indexOf].entry = entry;
      dictionaryEntrySelectedCopy = dictionaryEntrySelectedCopy.slice(
        0,
        indexOf + 1
      );
      if (entry && entry.dictionaryReferenceCode)
        dictionaryEntrySelectedCopy.push({
          name: entry.dictionaryReferenceCode,
          entry: null,
        });

      this.$emit("input", dictionaryEntrySelectedCopy);
    },
  },
};
</script>
